import React from "react";
import { Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { useEffect } from "react";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";

const label = { inputProps: { "aria-label": "Size switch demo" } };

// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// End

function AllAmenities() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [amenitiesList, setAmenitiesList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [status, setStatus] = React.useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
    setStatus(e.currentTarget.dataset.myValue);
    AmenitiesListing();
  };
  // End

  useEffect(() => {
    alert("In All Amenities");
    setStatus("true");
    AmenitiesListing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  async function AmenitiesListing() {
    let bodyFormData = {
      searchq: q,
      pageNo: 1,
      count: 20,
      status: status,
    };

    makePostRequest("amenities/alllisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data.rowCount);
          // setlength(response.data.data.rowCount)
          const data = response.data.data.rows;
          console.log(data);
          setAmenitiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [checked, setChecked] = React.useState(true);

  const handleChange = (event, amenityObj) => {
    setChecked(event.target.checked);
    alert(checked);
    console.log(amenityObj.amenity_name);
    console.log(event.target.checked);

    let inputdata = {
      amenity_id: amenityObj.amenity_id,
      amenity_name: amenityObj.amenity_name,
      society_id: amenityObj.society_id,
      status: event.target.checked,
    };

    makePostRequest("amenities/update", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          window.location.reload();
        } else {
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  };

  // delete Amenity
  async function deleteAmenity(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      makeGetRequest("amenities/delete/" + id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Amenity deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            AmenitiesListing();
          } else {
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          console.log("Invalid amenity!!", err);
        });
    }
  }

  return (
    <>
      <Grid
        container
        spacing={3}
        className="mainHeadingLine AmenitiesOuterMain"
      >
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">All Amenities</div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input
                      type="text"
                      placeholder="Search"
                      onChangeCapture={(e) => setQ(e.target.value)}
                    />

                    <MicIcon className="visitorMicIco" />
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem data-my-value={"true"} onClick={handleClose}>
                      Acive
                    </MenuItem>
                    <MenuItem data-my-value={"false"} onClick={handleClose}>
                      InActive
                    </MenuItem>
                  </Menu>
                </div>

                {amenitiesList.map((option) => (
                  <div className="visitContDiv" key={option.amenity}>
                    <div className="visitContProf">
                      <Zoom>
                        <img src={option.lstAmenityImages[0]} />
                      </Zoom>
                    </div>
                    <div className="visitCont1 resideNewContOut">
                      <div className="visitContLeft">
                        <h3 className="visitContHed">{option.amenity_name}</h3>
                        <p className="visitContTime">
                          Capacity {option.amenity_capacity}
                        </p>
                      </div>

                      <div className="visitBottCont timeView">
                        <p>
                          <b>First half :</b> <span>8:30 am to 7:30 pm</span>
                        </p>
                        <p>
                          <b>Secong half :</b> <span>8:30 am to 7:30 pm</span>
                        </p>
                      </div>

                      <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={() => navigate("/EditAmenity")}
                        />
                        <DeleteIcon
                          className="deleteBt"
                          onClick={() => deleteAmenity(option.amenity_id)}
                        />
                        <Switch
                          {...label}
                          checked={option.status}
                          size="small"
                          onChange={(event) => handleChange(event, option)}
                        />
                      </div>
                    </div>
                    <div className="visitCont2">
                      <div className="visitBottCont">
                        <p>Booking Duration:</p>
                        <b>{option.accessibility}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Access:</p>
                        {option.is_paid ? (
                          <b className="paidT">Paid</b>
                        ) : (
                          <b className="paidT">Free</b>
                        )}
                      </div>
                      <div className="visitBottCont">
                        <p>Charges:</p>
                        <b>{option.charges}/-</b>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <div className="modalMain">
        <Dialog
          open={open2}
          onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <AddCommitteeMemberModal />
            </div>
          </DialogContent>
        </Dialog>
      </div> */}
    </>
  );
}

export default AllAmenities;
